
export const GET_DISPUTE_LIST = "get_Dispute_list";
export const GET_DISPUTE_LIST_SUCCESS = "get_Dispute_list_success";
export const CHANGE_DISPUTE_ACTIVE_PAGE = "change_Dispute_active_page";
export const GET_DISPUTE_BLOCK = "get_Dispute_Block";
export const GET_DISPUTE_BLOCK_SUCCESS = "get_Dispute_Block_success";
export const DISPUTE_REASON = "Dispute_Reason";
export const DISPUTE_REASON_SUCCESS = "Dispute_Reason_Success";
export const ADD_DISPUTE = "Add_Dispute";
export const ADD_DISPUTE_SUCCESS = "Add_Dispute_Success";